import { Image } from "@chakra-ui/image";
import { Heading, VStack, Text, Container } from "@chakra-ui/layout";
import { Button } from "@chakra-ui/button";
import Link from "next/link";
import { useRouter } from "next/router";
import { useEffect } from "react";
import { getPaths } from "lib/utils/paths";
import { signIn } from "next-auth/react";
import type { UseFormReturn } from "react-hook-form";
import { useErrorToast } from "lib/utils/toasts/toasts";
import { useUser } from "lib/contexts/useUser";
import { useTranslations } from "next-intl";
import useTranslationConstants from "lib/utils/constants";

const FinalStep = ({
  FormController,
}: {
  FormController: UseFormReturn<any>;
}) => {
  const { loggedIn, loading } = useUser();
  const { query, replace } = useRouter();
  const errorToast = useErrorToast();
  const t = useTranslations("pages.register");
  const { LINKS } = useTranslationConstants();

  const handleSuccess = async () => {
    const formValues = FormController.getValues();
    try {
      await signIn(
        // eslint-disable-next-line i18next/no-literal-string
        "keycloak",
        {
          email: formValues.email,
          password: formValues.password,
          callbackUrl: window.location.href,
        });
      localStorage.removeItem("pending_form_data");
    } catch (error) {
      errorToast({
        title: t("errorMessage5"),
        error,
      });
    }
  };

  useEffect(() => {
    if (loading) return;
    if (query.success) {
      if (loggedIn) {
        localStorage.removeItem("registration_done");
        localStorage.removeItem("pending_form_data");
      } else {
        handleSuccess();
      }
    } else replace(getPaths.register.athlete.step(5));
  }, [loading]);

  // const ErrorMessage = (
  //   <>
  //     <Heading textAlign="center" as="h1" size="2xl">
  //       {t("errorMessage1")}
  //     </Heading>
  //     <Text fontSize="lg" textAlign="center">
  //       {t("finalStepAthleRegistrationContent5")}
  //       <br /> {t("finalStepAthleRegistrationContent6")}
  //     </Text>
  //     <Link passHref href={getPaths.register.athlete.step(4)}>
  //       <Button colorScheme="brandOrange">{t("backButton3")}</Button>
  //     </Link>
  //   </>
  // );

  return (
    <VStack minH="calc(100vh - 210px)" justify="center">
      <Container>
        <VStack spacing={[8, 8, 12, 16]}>
          <Image
            alt={t("altLogo")}
            src={LINKS.images.nameLogo}
            h={"35px"}
            objectFit="contain"
            objectPosition="center"
          />
          <Heading textAlign="center" as="h1" size="2xl" color="brandOrange.500">
            {t("finalStepAthleRegistrationContent1")}
          </Heading>
          <Text fontSize="lg" textAlign="center">
            {t("finalStepAthleRegistrationContent2")}
            <br /> {t("finalStepAthleRegistrationContent3")}
          </Text>
          <Link passHref href={getPaths.athlete.index()}>
            <Button colorScheme="brandOrange">{t("finalStepAthleRegistrationContent4")}</Button>
          </Link>
        </VStack>
      </Container>
    </VStack>
  );
};

export default FinalStep;
